<template>
    <div class="seminar-join">
        <div class="table-responsive table-seminar-join">
            <table class="table m-0">
                <thead>
                    <tr>
                        <th  style="min-width: 162px"> お申込みセミナー </th>
                        <th  style="min-width: 160px"> 開催日 </th>
                        <th  style="min-width: 150px"> 開催時間 </th>
                        <th  style="min-width: 200px"> 開催場所 </th>
                        <th  style="min-width: 200px"> 内容 </th>
                    </tr>
                </thead>
                <tbody>
                <template v-if="!tableData.length  || tableData.length === 0">
                    <tr class="empty-data">
                        <td colspan="5" class="el-table__empty-text">データなし。</td>
                    </tr>
                </template>
                <template v-for="(data, index) in tableData">
                    <tr :key="index" :value="index" >
                        <td>
                            {{data.groupName}}
                        </td>
                        <td>
                            {{ data.exhibitionDate }}
                        </td>
                        <td>
                            {{ data.exhibitionTime }}
                        </td>
                        <td style="text-align: left;">
                                <label v-if="data.url == null" v-html="getVenueHtml(data.venue)"/>
                                <el-link :href="data.url" target="_blank" v-else ><div v-html="getVenueHtml(data.venue)"/></el-link>
                        </td>
                        <td class="content">
                            <span v-html="seminar_content"></span>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div>
            <span>
                <el-link href="/member/info" target="_blank" style="font-size: 16px; color: #3a8ee6"><span class="gtm_seminar_kaiinhenkou_seminar">会員情報変更はこちら</span></el-link>
            </span>
        </div>
        <div class="seminar-join-info">
          <confirm-change-before-route ref="confirm-before-route">
            <form class="form mt1" @submit.prevent="handleRegisterButton">
                <table class="table-form">
                    <tbody>
                        <tr>
                            <td class="title required">お名前</td>
                            <td>
                                <table width="100%">
                                  <tr>
                                    <td style="border: none; padding: unset; width: 160px" class="child-table-td">
                                      <el-input type="text" v-model="seminar_participant.lastName" placeholder="姓" class="input"></el-input>
                                    </td>
                                    <td style="border: none; padding: unset; width: 30px" class="child-table-td">
                                      <span></span>
                                    </td>
                                    <td style="border: none; padding: unset; width: 160px" class="child-table-td">
                                      <el-input type="text" v-model="seminar_participant.firstName" placeholder="名" class="input"></el-input>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="border: none; padding: unset; width: 160px" class="child-table-td">
                                      <div v-if="isLastNameEmpty"><span class="text-danger">{{ this.$t('rules.required', { key: this.$t('member.last_name') }) }}</span></div>
                                      <div v-if="isLastNameOverMaxLength"><span class="text-danger">50文字以内で入力してください。</span></div>
                                    </td>
                                    <td style="border: none; padding: unset; width: 30px" class="child-table-td">
                                      <span></span>
                                    </td>
                                    <td style="border: none; padding: unset; width: 160px" class="child-table-td">
                                      <div v-if="isFirstNameEmpty"><span class="text-danger">{{ this.$t('rules.required', { key: this.$t('member.first_name') }) }}</span></div>
                                      <div v-if="isFirstNameOverMaxLength"><span class="text-danger">50文字以内で入力してください。</span></div>
                                    </td>
                                  </tr>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td class="title required">フリガナ</td>
                            <td>
                              <table width="100%">
                                <tr>
                                  <td style="border: none; padding: unset; width: 160px" class="child-table-td">
                                    <el-input type="text" v-model="seminar_participant.lastNameKana" placeholder="姓" class="input"></el-input>
                                    <div v-if="isLastNameKanaEmpty"><span class="text-danger">{{ this.$t('rules.required', { key: this.$t('member.last_name_kana') }) }}</span></div>
                                  </td>
                                  <td style="border: none; padding: unset; width: 30px" class="child-table-td">
                                    <span></span>
                                  </td>
                                  <td style="border: none; padding: unset; width: 160px" class="child-table-td">
                                    <el-input type="text" v-model="seminar_participant.firstNameKana" placeholder="名" class="input"></el-input>
                                    <div v-if="isFirstNameKanaEmpty"><span class="text-danger">{{ this.$t('rules.required', { key: this.$t('member.first_name_kana') }) }}</span></div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="border: none; padding: unset; width: 160px" class="child-table-td">
                                    <div v-if="isLastNameKanaOverMaxLength"><span class="text-danger">50文字以内で入力してください。</span></div>
                                    <div v-if="isLastNameKanaPatternErr"><span class="text-danger">全角カタカナで入力してください。</span></div>
                                  </td>
                                  <td style="border: none; padding: unset; width: 30px" class="child-table-td">
                                    <span></span>
                                  </td>
                                  <td style="border: none; padding: unset; width: 160px" class="child-table-td">
                                    <div v-if="isFirstNameKanaOverMaxLength"><span class="text-danger">50文字以内で入力してください。</span></div>
                                    <div v-if="isFirstNameKanaPatternErr"><span class="text-danger">全角カタカナで入力してください。</span></div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                        </tr>
                        <tr>
                          <td class="title">郵便番号</td>
                          <td>
                            <zip-code-input class="input" v-model="seminar_participant.zipCode" :isElem=true></zip-code-input>
                            <div v-if="isZipCodePatternErr"><span class="text-danger">{{ this.$t('rules.zip_code') }}</span></div>
                          </td>
                        </tr>
                        <tr>
                            <td class="title">お住いの都道府県</td>
                            <td>
                              <prefecture-select
                                v-model="seminar_participant.prefecture"
                                :prefectureMaster="prefectureMaster"
                              ></prefecture-select>
                            </td>
                        </tr>
                        <tr>
                            <td class="title">ご住所</td>
                            <td>
                              <el-input maxlength="200" type="text" v-model="seminar_participant.address" placeholder="ご住所" class="input"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="title required">メールアドレス</td>
                            <td>
                              <el-input type="text" v-model="seminar_participant.email" placeholder="メールアドレス" class="input"></el-input>
                              <div v-if="isEmailEmpty"><span class="text-danger">{{ this.$t('rules.required', { key: this.$t('member.email') }) }}</span></div>
                              <div v-if="isEmailPatternErr"><span class="text-danger">{{ this.$t('rules.email') }}</span></div>
                            </td>
                        </tr>
                        <tr>
                          <td class="title required">携帯電話番号</td>
                          <td>
                            <table width="100%">
                              <tr>
                                <td style="border: none; padding: unset; width: 160px">
                                  <el-input type="text" v-model="seminar_participant.mobilePhone" placeholder="携帯電話番号" class="input"></el-input>
                                </td>
                                <td style="border: none; padding: unset; width: 10px">
                                  <span></span>
                                </td>
                                <td style="border: none; padding: unset; width: 160px" class="note">
                                  <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
                                </td>
                              </tr>
                              <tr>
                                <td colspan="3" style="border: none; padding: unset">
                                  <div v-if="isMobilePhoneEmpty"><span class="text-danger">{{ this.$t('rules.required', { key: this.$t('member.mobile_phone') }) }}</span></div>
                                  <div v-if="isMobilePhonePatternErr"><span class="text-danger">{{ this.$t('rules.number', { key: this.$t('member.mobile_phone') }) }}</span></div>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                            <td class="title">電話番号</td>
                            <td>
                              <table width="100%">
                                <tr>
                                  <td style="border: none; padding: unset; width: 160px">
                                    <el-input type="text" v-model="seminar_participant.phone" placeholder="電話番号" class="input"></el-input>
                                  </td>
                                  <td style="border: none; padding: unset; width: 10px">
                                    <span></span>
                                  </td>
                                  <td style="border: none; padding: unset; width: 160px" class="note">
                                    <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3" style="border: none; padding: unset">
                                    <div v-if="isPhonePatternErr"><span class="text-danger">{{ this.$t('rules.number', { key: this.$t('member.phone') }) }}</span></div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                        </tr>
                        <tr>
                            <td class="title required">ご職業</td>
                            <td>
                                <p class="bold-text">[{{ data.vocations.name}}]</p>
                                <div class="wrap-row-mobile">
                                  <el-radio v-model="seminar_participant.profession_code" v-for="vocation in data.vocations.value" :key="vocation.itemKey" :label="vocation.itemKey">{{ vocation.itemValue }}</el-radio>
                                </div>
                                <div class="convert-to-col-on-phone no-margin-top-on-phone wrap-row-mobile" style="display: flex;margin-top: 5px">
                                  <el-radio style="line-height: 2; min-width: 70px" v-model="seminar_participant.profession_code"  :key="vocation_temp.itemKey" :label="vocation_temp.itemKey">{{ vocation_temp.itemValue }}</el-radio>
                                  <el-input v-model="seminar_participant.profession_etc" maxlength="30"></el-input>
                                </div>
                                <div v-if="isProfessionCodeEmpty"><span class="text-danger">※ご職業を入力してください</span></div>
                            </td>
                        </tr>
                        <tr>
                            <td class="title">無料個別相談</td>
                            <td>
                                <el-checkbox class="w-100-m" v-model="seminar_participant.free_consultation_flag" v-show="seminar_group_id == 1" style="padding-right:10px">希望する</el-checkbox>
                                <span v-show="seminar_group_id == 2">無料個別相談は相続セミナーのみ対象となります。ご了承ください。</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="title">本セミナーは何でお知りになりましたか？</td>
                            <td class="wrap-row-mobile">
                                <p class="bold-text">[{{ data.media_types.name}}] ※複数選択可</p>
                                <div style="display: flex; flex-flow: row wrap" class="convert-to-col-on-phone">
                                  <div class="col-2-on-phone" style="flex-grow: 1; width: 33%; display:inline-flex; white-space: normal" v-for="media in data.media_types.value" :key="media.itemKey">
                                    <el-checkbox style="flex-grow: 1" v-model="seminar_participant.media_type"  :key="media.itemKey" :label="media.itemKey">{{ media.itemValue }}</el-checkbox>
                                  </div>
                                </div>
                                <table width="100%">
                                  <tr v-for="media_special in data.media_type_special" :key="media_special.itemKey">
                                    <td style="border: none; padding: unset; width: 80px">
                                      <el-checkbox style="padding-right: 10px" v-model="seminar_participant.media_type"  :key="media_special.itemKey" :label="media_special.itemKey">{{ media_special.itemValue }}</el-checkbox>
                                    </td>
                                    <td style="border: none; padding: unset; padding-top: 10px" class="serminar-join-input">
                                      <el-input maxlength="30" v-model="seminar_participant.document_note" v-if="media_special.itemValue === '書籍'"></el-input>
                                      <el-input maxlength="30" v-model="seminar_participant.magazine_note" v-if="media_special.itemValue === '雑誌'"></el-input>
                                      <el-input maxlength="30" v-model="seminar_participant.other_note" v-if="media_special.itemValue === 'その他'"></el-input>
                                    </td>
                                  </tr>
                                </table>
                                <p class="bold-text">[{{ data.newspapers.name}}] ※複数選択可</p>
                                <el-checkbox v-model="seminar_participant.newspaper_type" v-for="news in data.newspapers.value" :key="news.itemKey" :label="news.itemKey">{{ news.itemValue }}</el-checkbox><br>
                                <p class="bold-text">[{{ data.magazines.name}}] ※複数選択可</p>
                                <el-checkbox v-model="seminar_participant.email_magazine_type" v-for="magazine in data.magazines.value" :key="magazine.itemKey" :label="magazine.itemKey">{{ magazine.itemValue }}</el-checkbox><br>
                                <p class="bold-text">[{{ data.searchs.name}}] ※複数選択可</p>
                                <el-checkbox v-model="seminar_participant.search_engine" v-for="search in data.searchs.value" :key="search.itemKey" :label="search.itemKey">{{ search.itemValue }}</el-checkbox>
                                <div class="mt1 pb-10px">
                                    <label>検索されたキーワード</label>
                                    <el-input maxlength="30" v-model="seminar_participant.keyword_note" placeholder="例）相続　相談"></el-input>
                                </div>
                                <p class="bold-text">[{{ data.homepages.name}}] ※複数選択可</p>
                                <div style="">
                                  <el-checkbox v-model="seminar_participant.home_page" style="margin-right: 30px; margin-top: 10px" v-for="home in data.homepages.value" :key="home.itemKey" :label="home.itemKey">{{ home.itemValue }}</el-checkbox>
                                  <table width="100%">
                                    <td style="border: none; padding: unset; width: 80px">
                                      <el-checkbox v-model="seminar_participant.home_page" style="margin-right: 30px; margin-top: 10px" :key="homepage_temp.itemKey" :label="homepage_temp.itemKey">{{ homepage_temp.itemValue }}</el-checkbox>
                                    </td>
                                    <td style="border: none; padding: unset; padding-top: 10px">
                                      <el-input maxlength="30" v-model="seminar_participant.home_page_note"></el-input>
                                    </td>
                                  </table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="title">ご質問・お問い合わせ等ございましたらお気軽にご記入下さい。</td>
                            <td>
                                <el-input maxlength="200" class="focus-no-border" type="textarea" :rows="3" v-model="seminar_participant.memo"></el-input>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="mt2 text-center link-mobile">
                    <el-checkbox v-model="seminar_participant.is_agree_to_privacy_policy" @change="handleChangeIsAgreeCheckbox">
                      <a href="https://legacy.ne.jp/privacy-customer/" target="_blank" rel="noopener noreferrer">「個人情報の取扱いについて」同意します</a>
                    </el-checkbox>
                    <div class="warning-policy" v-if="checkPolicy">
                        「「個人情報の取扱いについて」同意します」にチェックしてください
                    </div>
                </div>
                <div class="mt2 text-center">
                    <el-button :loading="loading" native-type="submit">参加する</el-button>
                    <el-button @click="handleBackButton">戻る</el-button>
                </div>
            </form>
          </confirm-change-before-route>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import ConfigDataApi from '@/api/config/data.js'
import SeminarClientApi from '@/api/seminar/seminar-client.js'
import ConfirmChangeBeforeRoute from '../../../../components/common/ConfirmChangeBeforeRoute'
import ZipCodeInput from '../../../../components/common/ZipCodeInput'
import ContactApi from '@/api/contact/contact-cl'
import PrefectureSelect from '@/components/common/PrefectureSelect'

export default {
  name: 'seminar-join',
  components: {
      ConfirmChangeBeforeRoute,
      ZipCodeInput,
      PrefectureSelect
  },
  data () {
    return {
      tableData: [],
      seminar_group_id: null,
      seminar_content: '',
      data: {
        vocations: [],
        media_types: [],
        newspapers: [],
        magazines: [],
        searchs: [],
        homepages: []
      },
      seminar_participant: {
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        email: '',
        phone: '',
        mobilePhone: '',
        zipCode: '',
        prefecture: '',
        address: '',
        free_consultation_flag: false,
        profession_code: null,
        profession_etc: '',
        media_type: [],
        document_note: '',
        magazine_note: '',
        other_note: '',
        newspaper_type: [],
        email_magazine_type: [],
        search_engine: [],
        keyword_note: '',
        home_page: [],
        home_page_note: '',
        memo: '',
        media_type_special: [],
        is_agree_to_privacy_policy: false
      },
      isConfirm: false,
      loading: false,
      isSubmitForm: false,
      homepage_temp: '',
      vocation_temp: '',
      prefectureMaster: [],
      isProfessionCodeEmpty: false,
      isFirstNameEmpty: false,
      isFirstNameOverMaxLength: false,
      isLastNameEmpty: false,
      isLastNameOverMaxLength: false,
      isFirstNameKanaEmpty: false,
      isFirstNameKanaOverMaxLength: false,
      isFirstNameKanaPatternErr: false,
      isLastNameKanaEmpty: false,
      isLastNameKanaOverMaxLength: false,
      isLastNameKanaPatternErr: false,
      isZipCodePatternErr: false,
      isMobilePhonePatternErr: false,
      isPhonePatternErr: false,
      isEmailPatternErr: false,
      checkPolicy: false,
      isEmailEmpty: false,
      isMobilePhoneEmpty: false
    }
  },
  mounted () {
    this.loadData()
    let $ = this._$
    $('html, body').delay(0).animate({
        scrollTop: $('.header').offset().top
    }, 0)
      this.seminar_participant.lastName = this.currentUser.lastName
      this.seminar_participant.lastNameKana = this.currentUser.lastNameKana
      this.seminar_participant.firstName = this.currentUser.firstName
      this.seminar_participant.firstNameKana = this.currentUser.firstNameKana
      this.seminar_participant.zipCode = this.currentUser.zipCode
      this.seminar_participant.email = this.currentUser.email
      this.seminar_participant.address = this.currentUser.address
      this.seminar_participant.phone = this.currentUser.phone
      this.seminar_participant.prefecture = this.currentUser.prefecture
      this.seminar_participant.mobilePhone = this.currentUser.mobilePhone
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  created () {
      this.checkUnjoin()
      this.loadPrefecture()
  },
  methods: {
    checkUnjoin () {
        let memberId = this.currentUser.id === undefined ? 0 : this.currentUser.id
        let seminarId = parseInt(this.$route.params.id)
        let _this = this
        SeminarClientApi.getSeminarList(memberId).then(response => {
            if (response.data.status === 200) {
                let groups = response.data.data
                groups.forEach(function (item, index) {
                    if (item.seminars.length > 0) {
                        item.seminars.forEach(function (seminarsItem, index) {
                            let id = seminarsItem.id
                            if (seminarId === id) {
                                if (seminarsItem.flag) {
                                    _this.$router.push({ name: 'seminar', params: { join: true } })
                                }
                            }
                        })
                    }
                })
            }
        })
    },
    async loadData () {
      const seminarId = this.$route.params.id
      if (seminarId) {
        await SeminarClientApi.referSeminar(seminarId).then(response => {
          if (response.data.status === 200) {
            const seminar = response.data.data.seminar
            const data = {
              'groupName': seminar.groupName,
              'exhibitionDate': seminar.exhibitionDate,
              'exhibitionTime': seminar.exhibitionTime,
              'venue': seminar.venue,
              'url': seminar.url
            }
            this.tableData.push(data)
            this.seminar_content = seminar.content
            this.seminar_group_id = seminar.groupId
          }
        })
        await ConfigDataApi.getConfigData().then(response => {
          if (response.data.status === 200) {
            const data = response.data.data
            this.data.vocations = data.seminar_vocation
            this.data.vocations.value = this.data.vocations.value.filter(item => {
                if (item.itemValue === 'その他') {
                    this.vocation_temp = item
                    return false
                }
                return true
            })
            this.data.media_types = data.seminar_meida
            this.data.newspapers = data.seminar_newspaper
            this.data.magazines = data.seminar_email_magazine
            this.data.searchs = data.seminar_search_engine
            this.data.homepages = data.seminar_home_page
            this.data.media_type_special = this.data.media_types.value.filter(item => item.itemValue === '書籍' || item.itemValue === '雑誌' || item.itemValue === 'その他')
            this.data.media_types.value = this.data.media_types.value.filter(item => item.itemValue !== '書籍' && item.itemValue !== '雑誌' && item.itemValue !== 'その他')
            this.data.homepages.value = this.data.homepages.value.filter(item => {
                if (item.itemValue === 'その他') {
                    this.homepage_temp = item
                    return false
                }
                return true
            })
          }
        })
      }
    },
    handleClearButton () {
      this.seminar_participant = {
        free_consultation_flag: false,
        profession_code: null,
        profession_etc: '',
        media_type: [],
        document_note: '',
        magazine_note: '',
        other_note: '',
        newspaper_type: [],
        email_magazine_type: [],
        search_engine: [],
        keyword_note: '',
        home_page: [],
        home_page_note: '',
        memo: '',
        is_agree_to_privacy_policy: false
      }
    },
    handleConfirmButton () {
      this.isConfirm = true
    },
    handleRegisterButton () {
      this.checkPolicy = !this.seminar_participant.is_agree_to_privacy_policy
      let isError = !this.validate()
      if (this.isConfirm && !isError) {
        const payload = {
          seminarId: this.$route.params.id,
          memberId: this.currentUser.id,
          participationFlag: true,
          professionCode: this.seminar_participant.profession_code,
          professionEtc: this.seminar_participant.profession_etc,
          freeConsultationFlag: this.seminar_participant.free_consultation_flag,
          fromMediaType: _.map(this.seminar_participant.media_type).join(','),
          documentNote: this.seminar_participant.document_note,
          magazineNote: this.seminar_participant.magazine_note,
          otherNote: this.seminar_participant.other_note,
          newspaperType: _.map(this.seminar_participant.newspaper_type).join(','),
          emailMagazineType: _.map(this.seminar_participant.email_magazine_type).join(','),
          searchEngine: _.map(this.seminar_participant.search_engine).join(','),
          keywordNote: this.seminar_participant.keyword_note,
          homePage: _.map(this.seminar_participant.home_page).join(','),
          homePageNote: this.seminar_participant.home_page_note,
          memo: this.seminar_participant.memo,
          isAgreeToPrivacyPolicy: this.seminar_participant.is_agree_to_privacy_policy,
          firstName: this.seminar_participant.firstName,
          lastName: this.seminar_participant.lastName,
          firstNameKana: this.seminar_participant.firstNameKana,
          lastNameKana: this.seminar_participant.lastNameKana,
          zipCode: this.seminar_participant.zipCode,
          prefecture: this.seminar_participant.prefecture,
          address: this.seminar_participant.address,
          email: this.seminar_participant.email,
          phone: this.seminar_participant.phone,
          mobilePhone: this.seminar_participant.mobilePhone
        }
        this.loading = true
        SeminarClientApi.joinSeminar(payload).then(response => {
          if (response.status === 200) {
            this.loading = false
            this.isSubmitForm = true
            this.$router.push({ name: 'seminar' })
          }
        })
      } else if (isError || !this.isConfirm) {
        this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
      }
    },
    handleBackButton () {
      this.isConfirm = false
      this.$router.back()
    },
    handleChangeIsAgreeCheckbox (val) {
      this.isConfirm = val
    },
    async loadPrefecture () {
      const res = await ContactApi.getInformPrefectureMaster()
      this.prefectureMaster = res.data.data
    },
    checkProfessionCodeEmpty () {
      let professionCode = this.seminar_participant.profession_code
      return professionCode === null || professionCode.length === 0
    },
    checkEmailAndMobilePhoneEmpty () {
      let email = this.seminar_participant.email
      let mobilePhone = this.seminar_participant.mobilePhone
      return (email === null || email.length === 0) && (mobilePhone === null || mobilePhone.length === 0)
    },
    checkFirstNameEmpty () {
      return this.seminar_participant.firstName === null || this.seminar_participant.firstName.length === 0
    },
    checkFirstNameMaxLength () {
      return this.seminar_participant.firstName !== null && this.seminar_participant.firstName.length > 50
    },
    checkLastNameEmpty () {
      return this.seminar_participant.lastName === null || this.seminar_participant.lastName.length === 0
    },
    checkLastNameMaxLength () {
      return this.seminar_participant.lastName !== null && this.seminar_participant.lastName.length > 50
    },
    checkFirstNameKanaEmpty () {
      return this.seminar_participant.firstNameKana === null || this.seminar_participant.firstNameKana.length === 0
    },
    checkFirstNameKanaMaxLength () {
      return this.seminar_participant.firstNameKana !== null && this.seminar_participant.firstNameKana.length > 50
    },
    checkFirstNameKanaPattern () {
      if (this.seminar_participant.firstNameKana === null || this.seminar_participant.firstNameKana.length === 0) {
        return true
      }
      let regexFirstNameKana = new RegExp(/^[ァ-ンヴー]+$/)
      return regexFirstNameKana.test(this.seminar_participant.firstNameKana)
    },
    checkLastNameKanaEmpty () {
      return this.seminar_participant.lastNameKana === null || this.seminar_participant.lastNameKana.length === 0
    },
    checkLastNameKanaMaxLength () {
      return this.seminar_participant.lastNameKana !== null && this.seminar_participant.lastNameKana.length > 50
    },
    checkLastNameKanaPattern () {
      if (this.seminar_participant.lastNameKana === null || this.seminar_participant.lastNameKana.length === 0) {
        return true
      }
      let regexLastNameKana = new RegExp(/^[ァ-ンヴー]+$/)
      return regexLastNameKana.test(this.seminar_participant.lastNameKana)
    },
    checkZipCodePattern () {
      if (this.seminar_participant.zipCode === null || this.seminar_participant.zipCode.length === 0) {
        return true
      }
      let regexZipCode = new RegExp(/^[0-9]{3}-[0-9]{4}$/)
      return regexZipCode.test(this.seminar_participant.zipCode)
    },
    checkMobilePhonePattern () {
      if (this.seminar_participant.mobilePhone === null || this.seminar_participant.mobilePhone.length === 0) {
        return true
      }
      let regexMobilePhone = new RegExp(/^\d{3}-\d{4}-\d{4}$/)
      return regexMobilePhone.test(this.seminar_participant.mobilePhone)
    },
    checkPhonePattern () {
      if (this.seminar_participant.phone === null || this.seminar_participant.phone.length === 0) {
        return true
      }
      let regexPhone = new RegExp(/^(?:\d{2}-\d{4}|\d{3}-\d{3}|\d{4}-\d{2}|\d{5}-\d)-\d{4}$/)
      return regexPhone.test(this.seminar_participant.phone)
    },
    checkEmailPattern () {
      if (this.seminar_participant.email === null || this.seminar_participant.email.length === 0) {
        return true
      }
      let regexEmail = new RegExp(/^[a-zA-Z0-9]{1}[a-zA-Z0-9_.-]*@{1}(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|([a-zA-Z0-9_.-]{1,}\.[a-zA-Z0-9]{2,}))$/)
      return regexEmail.test(this.seminar_participant.email)
    },
    checkEmailEmpty () {
      return this.seminar_participant.email === null || this.seminar_participant.email.length === 0
    },
    checkMobilePhoneEmpty () {
      return this.seminar_participant.mobilePhone === null || this.seminar_participant.mobilePhone.length === 0
    },
    validate () {
      let errorCnt = 0
      this.isProfessionCodeEmpty = this.checkProfessionCodeEmpty()
      errorCnt += this.isProfessionCodeEmpty ? 1 : 0
      this.isFirstNameEmpty = this.checkFirstNameEmpty()
      errorCnt += this.isFirstNameEmpty ? 1 : 0
      this.isFirstNameOverMaxLength = this.checkFirstNameMaxLength()
      errorCnt += this.isFirstNameOverMaxLength ? 1 : 0
      this.isLastNameEmpty = this.checkLastNameEmpty()
      errorCnt += this.isLastNameEmpty ? 1 : 0
      this.isLastNameOverMaxLength = this.checkLastNameMaxLength()
      errorCnt += this.isLastNameOverMaxLength ? 1 : 0
      this.isFirstNameKanaEmpty = this.checkFirstNameKanaEmpty()
      errorCnt += this.isFirstNameKanaEmpty ? 1 : 0
      this.isFirstNameKanaOverMaxLength = this.checkFirstNameKanaMaxLength()
      errorCnt += this.isFirstNameKanaOverMaxLength ? 1 : 0
      this.isFirstNameKanaPatternErr = !this.checkFirstNameKanaPattern()
      errorCnt += this.isFirstNameKanaPatternErr ? 1 : 0
      this.isLastNameKanaEmpty = this.checkLastNameKanaEmpty()
      errorCnt += this.isLastNameKanaEmpty ? 1 : 0
      this.isLastNameKanaOverMaxLength = this.checkLastNameKanaMaxLength()
      errorCnt += this.isLastNameKanaOverMaxLength ? 1 : 0
      this.isLastNameKanaPatternErr = !this.checkLastNameKanaPattern()
      errorCnt += this.isLastNameKanaOverMaxLength ? 1 : 0
      this.isZipCodePatternErr = !this.checkZipCodePattern()
      errorCnt += this.isZipCodePatternErr ? 1 : 0
      this.isMobilePhonePatternErr = !this.checkMobilePhonePattern()
      errorCnt += this.isMobilePhonePatternErr ? 1 : 0
      this.isPhonePatternErr = !this.checkPhonePattern()
      errorCnt += this.isPhonePatternErr ? 1 : 0
      this.isEmailPatternErr = !this.checkEmailPattern()
      errorCnt += this.isEmailPatternErr ? 1 : 0
      this.isEmailEmpty = this.checkEmailEmpty()
      errorCnt += this.isEmailEmpty ? 1 : 0
      this.isMobilePhoneEmpty = this.checkMobilePhoneEmpty()
      errorCnt += this.isMobilePhoneEmpty ? 1 : 0
      if (errorCnt > 0) {
        return false
      }
      return true
    },
    alertMessage (message, title) {
        this.$alert(message, title, {
            confirmButtonText: this.$t('commons.ok')
        })
    },
    getVenueHtml (venue) {
        let venueAry = venue.split('　')
        let output = ''
        venueAry.forEach(element => {
            output = output + element + '<br>'
        })
        return output
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isSubmitForm) {
      next()
    } else {
      this.$refs['confirm-before-route'].openConfirm().then((confirm) => {
        if (confirm) {
          next()
        } else {
          next(false)
        }
      })
    }
  }
}
</script>

<style>
    @import './seminar-join.css';
    @import '../../../../assets/css/custom.css';
</style>
<style scoped>
  .focus-no-border{
    outline: unset;
  }
  .focus-no-border >>> .el-textarea__inner:focus{
    border-color: #c0b283 !important;
  }
  @media screen and (max-width:970px) {
    .col-2-on-phone{
      width: 50% !important;
    }
  }
  @media screen and (max-width:768px){
    .convert-to-col-on-phone{
      flex-direction: column !important;
    }
    .col-2-on-phone{
      width: 100% !important;
    }
    .no-margin-top-on-phone{
      margin-top: unset !important;
    }
    .no-margin-top-on-phone >>> .el-radio{
      line-height: 18px !important;
    }
  }
  .col-2-on-phone >>> .el-checkbox .el-checkbox__label{
    display: unset;
    white-space: normal;
  }

  _:-ms-lang(x)::-ms-backdrop, table {
    table-layout: fixed;
  }

  .table-seminar-join table td.content {
      text-align: unset;
  }
   _:-ms-lang(x)::-ms-backdrop, .table-seminar-join table td.content {
      text-align: inherit;
   }
  .table-seminar-join table td .content {
      text-align: unset;
  }
  .table-seminar-join table td .content img {
      width: 100%;
      height: 150px;
  }
  .table-seminar-join table .btn-delete {
      background-color: #d9534f;
      border-color: #d43f3a;
      border-radius: 5px;
      color: white;
      font-size: 18px;
      cursor: pointer;
  }
  .table-seminar-join table .note {
      margin-top: 10px;
      padding-left: 5px;
      margin-bottom: 10px;
  }
  .table-seminar-join table tr td a {
      color: #3a8ee6 !important;
  }
  .table-seminar-join {
      width: 100%;
      margin: 1em auto;
  }
  .table-seminar-join table {
      width: 100%;
      margin: 1em auto;
  }
  .table-seminar-join .table td {
      text-align: center;
      padding: 1em;
      font-size: 14px;
      vertical-align: top;
  }
  .table-seminar-join .table .bg-blue td {
      background: #8edbff;
  }
  .table-seminar-join .table .bg-lightblue td {
      background: #e6f6fe;
  }
  .table-seminar-join .table th {
      text-align: center;
      background-color: #f7f0df ;
      padding: 1em;
      font-size: 16px;
      font-weight: bold;
      color: #321007;
  }
  .table-seminar-join.table-responsive {
      border-radius: 10px;
  }
  .table-seminar-join.table-responsive tr:hover>td {
      background: #FAF7F0;
  }
  .table-seminar-join tr {
      background-color: #fffdf7;
  }
  .table-seminar-join .table th {
      vertical-align: middle;
  }
    .table-seminar-join .table {
        /*border: 1px solid #d6d6d6;*/
        border-collapse: separate;
        border-radius: 10px;
    }
    .table-seminar-join .table thead + tbody td,
    .table-seminar-join .table tr + tr td {
        border-top: 1px solid #d6d6d6;
    }
    .table-seminar-join .table td {
        border-bottom: none;
    }
    .table-seminar-join .table thead th + th,
    .table-seminar-join .table tbody th + td,
    .table-seminar-join .table tbody td + td {
      border-left: 1px solid #d6d6d6;
    }
  .table-seminar-join thead {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
  }
  .table-seminar-join tr:last-child {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
  }
  .table-seminar-join.table-responsive {
      border: 1px solid #d6d6d6;
  }
  .table-responsive tr td:first-child,
  .table-responsive tr th:first-child {
      border-left: unset;
  }
  .table-responsive tr th {
      border-top: unset;
  }
  .table-responsive tr td:last-child,
  .table-responsive th:last-child {
      border-right: unset;
  }
  .table-responsive tr:last-child td {
      border-bottom: unset;
  }
</style>
